// importando estilização do componente
import { useState } from 'react'
import { Styled } from './Styled';
import icons from '../../img/icons/icons';
import { FullCertificado } from '../../shared/components/layout/Certificado/FullCertificado';

export const Certificado: React.FC = () => {
    const [codigo, setCodigo] = useState("");
    const [showCertificado, setShowCertificado] = useState(false);

    const handleSearch = () => {
        if (codigo.trim()) {
            setShowCertificado(true);
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <>
            <Styled.Wrapper>
                <Styled.BackgroundVideo
                    src={require('../../img/Video.mp4')}
                    autoPlay
                    loop
                    muted
                    playsInline
                />
                <Styled.Overlay />
                <Styled.HomeIcon src={icons.home} alt="Home" onClick={() => window.location.href = '/'} />
                <Styled.CenterBox>
                    <Styled.Card>
                        <Styled.CertificadoIcon src={icons.CertificadoPremium} alt="Certificado Premium" />
                        <Styled.InputBox>
                            <Styled.Input
                                type="text"
                                placeholder="Insira o código do seu certificado para consultar"
                                value={codigo}
                                onChange={e => setCodigo(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                            <Styled.SearchButton onClick={handleSearch}>
                                <Styled.SearchIcon src={icons.SearchWhite} alt="Buscar" />
                            </Styled.SearchButton>
                        </Styled.InputBox>
                    </Styled.Card>
                </Styled.CenterBox>
            </Styled.Wrapper>
            
            {showCertificado && (
                <FullCertificado 
                    codigoCTR={codigo} 
                    onClose={() => setShowCertificado(false)} 
                />
            )}
        </>
    )
}
// aqui estamos exportando nosso componente
